import { useAtomValue } from 'jotai';
import _isEmpty from 'lodash/isEmpty';
import { useStageAtoms } from '../../../labelling-v2/components/stage-scope/hooks';
export const useIsToolDisabled = () => {
  const {
    isLoadingAtom,
    currentFrameAnnotationUnderUserReviewAtom
  } = useStageAtoms();
  const isToolLoading = useAtomValue(isLoadingAtom);
  const annotationUnderUserReview = useAtomValue(currentFrameAnnotationUnderUserReviewAtom);
  return isToolLoading || !_isEmpty(annotationUnderUserReview);
};